"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
// LeftSidebar.tsx
const material_1 = require("@mui/material");
const react_1 = require("react");
const SidebarTabs_1 = __importDefault(require("./SidebarTabs"));
const SearchInput_1 = __importDefault(require("./SearchInput"));
const FormList_1 = __importDefault(require("./FormList"));
const FormSelection_1 = __importDefault(require("./FormSelection"));
const SessionContext_1 = require("../context/SessionContext");
const api_1 = require("../api");
const LeftSidebar = () => {
    const { session } = (0, SessionContext_1.useSession)();
    const [selectedTab, setSelectedTab] = (0, react_1.useState)("existing");
    const [search, setSearch] = (0, react_1.useState)("");
    const [selectedFormId, setSelectedFormId] = (0, react_1.useState)((session === null || session === void 0 ? void 0 : session.formId) || null);
    const handleSelectForm = (form) => {
        setSelectedFormId(form._id);
    };
    const handleRemoveForm = () => {
        setSelectedFormId(null);
    };
    if ((session === null || session === void 0 ? void 0 : session.docType) !== api_1.DOC_TYPE.FORM) {
        return;
    }
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { width: { xs: "100%", sm: 240 }, 
        // height="100%"
        borderRight: "1px solid #eee", p: 2, bgcolor: "#fafafa", display: "flex", flexDirection: "column", overflow: "auto", children: !selectedFormId ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(SidebarTabs_1.default, { selectedTab: selectedTab, setSelectedTab: setSelectedTab }), selectedTab === "existing" && ((0, jsx_runtime_1.jsx)(SearchInput_1.default, { search: search, setSearch: setSearch })), (0, jsx_runtime_1.jsx)(FormList_1.default, { selectedTab: selectedTab, search: search, onSelectForm: handleSelectForm })] })) : ((0, jsx_runtime_1.jsx)(FormSelection_1.default, { formId: selectedFormId, onBack: handleRemoveForm })) }));
};
exports.default = LeftSidebar;
